import { render, staticRenderFns } from "./OnboardingVideoModal.vue?vue&type=template&id=02951a9e&scoped=true&"
import script from "./OnboardingVideoModal.vue?vue&type=script&lang=js&"
export * from "./OnboardingVideoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02951a9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02951a9e')) {
      api.createRecord('02951a9e', component.options)
    } else {
      api.reload('02951a9e', component.options)
    }
    module.hot.accept("./OnboardingVideoModal.vue?vue&type=template&id=02951a9e&scoped=true&", function () {
      api.rerender('02951a9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/OnboardingVideoModal.vue"
export default component.exports